module.exports = __webpack_public_path__ + "static/img/bg_coupon_tag_used.4dbedb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_tag_used.png
// module id = zTyo
// module chunks = 0